import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from "@/components/uploadImagetow";
import { businessGameplayMapList } from "@/api/dataAll/dataAll";
import { gmTool } from "@/mixins/index";
export default {
  name: "property",
  mixins: [gmTool],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      upData: {}
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.upData.game_id = _this.rawData.game_id;
              _this.paramsData.game_id = _this.rawData.game_id;

              _this.getList(1);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    getList: function getList(e) {
      var _this2 = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      businessGameplayMapList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data.data || [];
          ;
          _this2.total = res.data.total ? parseInt(res.data.total) : 0;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    Refresh: function Refresh() {
      this.list = [];
      this.getList(1);
    },
    exportdata: function exportdata() {
      var _this3 = this;

      businessGameplayMapList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: _this3.$t('playName'),
            prop: "play_name"
          }, {
            label: _this3.$t('playMark'),
            prop: "play_mark"
          }];
          var data = res.data;

          _this3.$export.csv({
            columns: columns,
            data: data,
            noHeader: true,
            title: _this3.$route.meta.title
          });
        }
      });
    }
  }
};